module.exports = __webpack_public_path__ + "img/moon-01.81d02755.png";